import React from 'react';

import TellyChair from '../../images/telly-chair.svg';

interface ComingSoonProps {
	body?: string;
	title?: string;
}

export default function ComingSoon({ body, title = 'Coming Soon' }: ComingSoonProps) {
	return (
		<div className="coming-soon">
			<div className="coming-soon-image">
				<div className="coming-soon-gradient" />
				<img
					src={TellyChair}
					alt="Telly sitting in a film production chair"
				/>
			</div>
			<h4 className="coming-soon-title bl-font-header">{title}</h4>
			{body && (
				<div className="coming-soon-text bl-font-p2">{body}</div>
			)}
		</div>
	);
}
